module.exports = __webpack_public_path__ + "static/media/beef1.ea818a9f.jpg";